import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { intlMessageShape } from 'sb-react-intl'

import Message from 'components/text/Message/Message'

import s from './Text.scss'


const sizes = [
  '48-56',
  '38-56',
  '38-48',
  '32-40',
  '28-40',
  '22-32',
  '20-24',
  '18-24',
  '16-24',
  '16-20',
  '14-24',
  '14-16',
  '12-24',
  '12-16',
]

const getWeight = ({ inherit, semibold, bold }) => {
  if (bold) return 'bold'
  if (semibold) return 'semibold'
  if (inherit) return false
  return 'normal'
}

const Text = (props) => {
  const {
    // TODO remove "values" from here... it should be inside message!!!
    children, id, className, tag, message,
    inherit, size, muted, semibold, bold, align, uppercase,
    html, values, color, italic, letterSpacing,
    onClick,
    dataTestId,
  } = props

  if (onClick && tag !== 'button') {
    console.error('You can\'t use "onClick" without passing tag === "button". Create components ADA friendly!')
  }

  if (size && !sizes.includes(size)) {
    console.error(`Wrong size "${size}" passed to Text component`)
  }

  const weight = getWeight({ inherit, semibold, bold })

  const rootClassName = cx(className,  {
    [s[`size-${size}`]]: !inherit && size,
    [s[weight]]: weight,
    [s.uppercase]: uppercase,
    [s[`align-${align}`]]: align,
    [s.muted]: muted,
    [s[color]]: color,
    [s.italic]: italic,
    [s.letterSpacing]: letterSpacing,
  })

  if (message) {
    return (
      <Message
        id={id}
        className={rootClassName}
        tag={tag}
        text={message}
        html={html}
        values={values}
        onClick={onClick}
        dataTestId={dataTestId}
      />
    )
  }

  return React.createElement(tag, {
    id,
    className: rootClassName,
    'data-testid': dataTestId,
    onClick,
  }, children)
}

Text.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  message: PropTypes.oneOfType([
    PropTypes.shape(intlMessageShape),
    PropTypes.string,
  ]),
  tag: PropTypes.string,
  inherit: PropTypes.bool,
  size: PropTypes.oneOf([ '48-56', '38-56', '38-48', '32-40', '28-40', '22-32', '20-24', '18-24', '16-20', '16-24', '14-24', '14-16', '12-24', '12-16' ]),
  align: PropTypes.oneOf([ 'left', 'center', 'right' ]),
  semibold: PropTypes.bool,
  bold: PropTypes.bool,
  uppercase: PropTypes.bool,
  muted: PropTypes.bool,
  color: PropTypes.oneOf([
    'white',
    'white-warm',
    'white-cold',
    'gray-30',
    'gray-50',
    'gray-70',
    'gray-80',
    'black',
    'brand',
    'error',
    'gray', // TODO deprecated, use gray-70
  ]),
  html: PropTypes.bool,
  italic: PropTypes.bool,
  letterSpacing: PropTypes.bool,
  values: PropTypes.object,
  onClick: PropTypes.func,
  dataTestId: PropTypes.string,
}

Text.defaultProps = {
  tag: 'div',
  size: '16-24',
}


export default Text
